export var isRNDM = process.env.REACT_APP_IS_RNDM === 'false' ? false : true;
